import { render, staticRenderFns } from "./WorkoutDetails.vue?vue&type=template&id=70442269&scoped=true"
import script from "./WorkoutDetails.vue?vue&type=script&lang=js"
export * from "./WorkoutDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkoutDetails.vue?vue&type=style&index=0&id=70442269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70442269",
  null
  
)

export default component.exports